import { ChangeDetectionStrategy, Component } from "@angular/core";
import { IIconComponent, ModalOptions, SpinnerComponent } from "@front/m19-ui";
import { TranslocoDirective } from "@jsverse/transloco";

@Component({
  selector: "app-upload-amazon-loading-modal",
  standalone: true,
  imports: [IIconComponent, SpinnerComponent, TranslocoDirective],
  template: `<div class="m-4" *transloco="let t">
    <div class="mb-2 flex items-center gap-x-2">
      <IIcon name="progressUpload" class="text-3xl text-gray-500" />
      <h4 class="m-0">{{ t("sb-form-creative.uploading_to_amazon") }}</h4>
    </div>
    <p class="text-gray-500">{{ t("sb-form-creative.wait_upload") }}</p>
    <ISpinner [display]="true" />
  </div> `,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class UploadAmazonLoadingModalComponent {
  static readonly defaultModalOptions: Omit<ModalOptions<unknown>, "data"> = { size: "md" };
}
